import { Color, Vector3 } from 'three';
import React from 'react';
import PropTypes from 'prop-types';
import chroma from 'chroma-js';

import {PCB_SIZE, COPPER_COLOR, OPACITY, COPPER_THICKNESS} from '../../../constants/globals';

const CopperStrip = (props) => {
    const {
      position,
      width,
      height,
      onMouseLeave,
      onMouseEnter,
      onClick,
      hoverHighlight,
      warningHighlight,
    } = props;
    const layerPosition = new Vector3(
        position.x,
        position.y,
        position.z
      )
    const depth  = PCB_SIZE.depth;
    const color = hoverHighlight ? chroma(COPPER_COLOR).brighten().hex() : COPPER_COLOR

    return (
      <group position={layerPosition}>
        <mesh
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={onClick}
        >
          <boxGeometry
            width={width}
            height={height}
            depth={depth}
          />
          <meshPhongMaterial
            opacity={OPACITY}
            color={new Color(color)}
            transparent
          />
        </mesh>
        {hoverHighlight ? (
          <mesh ignorePointerEvents>
            <boxGeometry
              width={width}
              height={height}
              depth={depth}
            />
            <materialResource
              resourceId="highlightMaterial"
            />
          </mesh>
        ) : null}
        {warningHighlight ? (
          <mesh ignorePointerEvents>
            <boxGeometry
              width={width}
              height={height}
              depth={depth}
            />
            <materialResource
              resourceId="warningMaterial"
            />
          </mesh>
        ) : null}
      </group>
    );
};

CopperStrip.propTypes = {
  position:         PropTypes.instanceOf(Vector3).isRequired,
  width:            PropTypes.number.isRequired,
  height:           PropTypes.number,
  onMouseEnter:     PropTypes.func.isRequired,
  onMouseLeave:     PropTypes.func.isRequired,
  onClick:          PropTypes.func.isRequired,
  hoverHighlight:   PropTypes.bool,
  warningHighlight: PropTypes.bool,
}

CopperStrip.defaultProps = {
  height:         COPPER_THICKNESS,
  hoverHighlight: false,
  warningHighlight: false,
}

export default CopperStrip;



// WEBPACK FOOTER //
// ./src/components/common/materials/CopperStrip.js